<template>
  <div class="content">
    <v-card class="d-flex pa-1 bg" outlined>
      <div class="mr-auto d-flex">
        <span style="margin-top: 6px; margin-left: 10px">{{ $t('prop.key') }} :</span>
        <v-toolbar dense flat height="32px">
          <!-- eslint-disable-next-line prettier/prettier -->
          <v-autocomplete name="propKey" v-model="srchProp.key" :items="keyList" @update:search-input="searchKey"
            :label="$t('prop.ph.key')" clearable dense flat hide-no-data hide-details solo style="width: 260px">
          </v-autocomplete>
        </v-toolbar>
        <span style="margin-top: 6px; margin-left: 10px">{{ $t('prop.desc') }} :</span>
        <v-toolbar dense flat height="32px">
          <!-- eslint-disable-next-line prettier/prettier -->
          <v-autocomplete name="propDesc" v-model="srchProp.desc" :items="descList" @update:search-input="searchDesc"
            :label="$t('prop.ph.desc')" clearable dense flat hide-no-data hide-details solo style="width: 360px">
          </v-autocomplete>
        </v-toolbar>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" class="ml-2 mt-1" x-small color="primary" @click="retrieve(0)" @click.ctrl.alt="retrieve(1)">
              <v-icon small>mdi-magnify</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('common.retrieve') }}</span>
        </v-tooltip>
      </div>
    </v-card>
    <!-- eslint-disable-next-line prettier/prettier -->
    <v-data-table :headers="headers" :items="propList" item-key="key" :loading="loading"
      class="elevation-1 table-content" height="400" dense fixed-header disable-pagination hide-default-footer
    >
      <template #item.value="{ value }">
        <div class="col-ellipsis" :style="{ 'max-width': '190px' }">{{ value }}</div>
      </template>
      <template #item.description="{ value }">
        <div class="col-ellipsis" :style="{ 'max-width': '460px' }">{{ value }}</div>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" small left color="primary" @click="updateProp(item)">mdi-pencil-box-multiple-outline</v-icon>
          </template>
          <span>{{ $t('common.edit') }}</span>
        </v-tooltip>
      </template>
    </v-data-table>
    <PropertyForm ref="propertyForm" @reRetrieve="reRetrieve" />
  </div>
</template>

<script>
import { api } from '@/api/common/instances';
import PropertyForm from './PropertyForm.vue';

export default {
  components: {
    PropertyForm,
  },
  data() {
    return {
      loading: false,
      showForm: false,
      propList: [],
      keyList: [],
      descList: [],
      srchProp: {},
      headers: [
        { text: this.$t('prop.key'), value: 'key', width: '190px', sortable: false },
        { text: this.$t('prop.value'), value: 'value', width: '190px', sortable: false },
        { text: this.$t('prop.desc'), value: 'description', width: '460px', sortable: false },
        { text: '', value: 'actions', width: '30px', sortable: false },
      ],
      isSttm: 0,
    };
  },
  methods: {
    async searchKey(input) {
      // v-autocomplete 컴포넌트가 created() 되면 초기값이 null이어서 keyList가 빈 array이어서 무한루프가 발생한다.
      // 또한, 값이 변하지 않은 상태이면 keyList를 조회하러 갈 필요없다.
      if (input === null || input == this.srchProp.key) return;
      this.keyList = await this.autoSearch('key', { key: input });
      // 실제 DB에 없는 key 명('%'문자가 포함된 것)을 입력할 수 있도록 현재 입력된 값을 items에 추가해준다.
      this.keyList.unshift(input);
    },
    async searchDesc(input) {
      // v-autocomplete 컴포넌트가 created() 되면 초기값이 null이어서 descList가 빈 array이어서 무한루프가 발생한다.
      // 또한, 값이 변하지 않은 상태이면 descList를 조회하러 갈 필요없다.
      if (input === null || input == this.srchProp.desc) return;
      this.descList = await this.autoSearch('desc', { description: input });
      // 실제 DB에 없는 description('%'문자가 포함된 것)을 입력할 수 있도록 현재 입력된 값을 items에 추가해준다.
      this.descList.unshift(input);
    },
    async autoSearch(uri, params) {
      const { data: items } = await api.get(`/prefer/prop/auto-search/${uri}`, {
        params: {
          ...params,
        },
      });
      return items;
    },
    reRetrieve() {
      this.retrieve(this.isSstm);
    },
    async retrieve(isSstm) {
      this.loading = true;
      this.isSstm = isSstm;
      const { data: items } = await api.get('/prefer/prop/like-all', {
        params: {
          key: this.srchProp.key,
          systemProperty: isSstm,
          description: this.srchProp.desc,
        },
      });
      this.propList = items;
      this.loading = false;
    },
    updateProp(item) {
      this.$refs.propertyForm.$data.isShowForm = true;
      this.$refs.propertyForm.$data.property = { key: item.key, value: item.value, description: item.description };
    },
  },
};
</script>
<style scoped>
.content {
  width: 1000px;
}
.table-content {
  max-width: 1000px;
}
.v-toolbar ::v-deep .v-toolbar__content {
  padding: 4px;
}
.col-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
